/* tslint:disable:variable-name */
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  public production = environment.production;
  public mock = environment.mock;
  public is_private_app = environment.is_private_app;
  public public_api_endpoint = environment.public_api_endpoint;
  public private_api_endpoint = environment.private_api_endpoint;
  public deploy_on_k8s = environment.deploy_on_k8s;
  public notify_service = environment.notify_service;
  public public_api_endpoint_digital = environment.public_api_endpoint_digital;
  public genimage_api_base_url = environment.genimage_api_base_url;
  // Cờ dự phòng khi WAF (Cloudflare) chặn request PDF.js range: true = view PDF luon lay toan bo file ve (blob)
  // kieu boolean | string vi gia tri ghi de tu env.js (sau sed) co the la chuoi 'true'/'false'
  public pdf_view_full_download: boolean | string = environment.pdf_view_full_download;

  sme_portal_url = environment.sme_portal_url;
  sme_client_id = environment.sme_client_id;
  vcontract_url = environment.vcontract_url;

  constructor() {
  }

  // true neu bat che do luon tai toan bo file PDF ve (du phong khi WAF chan request range cua PDF.js)
  public get pdfViewFullDownload(): boolean {
    return this.pdf_view_full_download === true || this.pdf_view_full_download === 'true';
  }
}
